module.exports = __webpack_public_path__ + "img/des_kalinba_5.31ce69cd.jpg";